import React from 'react';
import classnames from 'classnames';
import { ClosableOverlay } from '../closable-overlay/closable-overlay';
import styles from './actions-panel.scss';
export const AllCardsClosableOverlay = (props) => {
    const contentClassName = classnames(props.contentClassName, styles['all-cards-overlay-content']);
    return React.createElement(ClosableOverlay, { ...props, contentClassName: contentClassName });
};
//# sourceMappingURL=all-cards-closable-overlay.js.map